<template>
  <footer class="tq__footer">
    <div class="tq__footer-info">
      <a href="mailto:sales@tqvibe.com" class="tq__footer-link"
        >sales@tqvibe.com</a
      >
      <h5 class="tq__footer-dir">
        Dr Alt 3-301, Zona Urbana R&iacute;o Tijuana 22210 Tijuana, Baja
        California, M&eacute;xico
      </h5>
    </div>
    <div class="tq__footer-icons">
      <a
        class="icon--facebook"
        href="https://www.facebook.com/teqvibe/"
        target="_blank"
      >
        <facebook-icon></facebook-icon>
      </a>
      <a
        class="icon--linkedin"
        href="https://www.linkedin.com/company/teqvibe"
        target="_blank"
      >
        <linkedin-icon></linkedin-icon>
      </a>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.tq__footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: absolute;
  padding: 1.6rem;
  width: 90%;
  bottom: 0;
  font-family: Roboto;
  @include mq-max(991px) {
    width: 100%;
  }
  &-link {
    color: #f05a28;
    font-size: 4rem;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 4.8rem;
    @include mq-max(991px) {
      font-size: 2.4rem;
    }
  }
  &-dir {
    color: $black-blue;
    font-size: 2.4rem;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 2.4rem;
    @include mq-max(991px) {
      font-size: 1.4rem;
    }
  }
  &-info {
    @include mq-max(991px) {
      max-width: 75%;
    }
  }
  &-icons {
    a {
      font-size: 3rem;
      color: rgba($black-blue, 0.5);
      cursor: pointer;
      background-color: $white;
      border-radius: 50%;
      box-shadow: 0 0 10px 1px;
      transition: 0.5s all ease;
      &:first-child {
        margin-right: 1rem;
      }
      span {
        width: 4rem;
        color: $light-blue;
        svg {
          height: 2.5rem;
          right: 6px;
          top: 6px;
        }
        &:hover {
          color: $black-blue;
        }
      }
      &:hover {
        color: $black-blue;
      }
    }
    .icon {
      &--linkedin {
        svg {
          right: 3px;
        }
      }
    }
    @include mq-max(450px) {
      display: flex;
    }
  }
}
</style>
